/* istanbul ignore file */
import { DispatchWithoutAction, useReducer } from 'react';

export function useForceUpdate(): DispatchWithoutAction {
  const [, forceUpdate] = useReducer((x) => x + 1, 0); // forceUpdate official FAQ https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
  return forceUpdate;
}
